import { config } from '../config/environment';
import { Pin, Reveal } from '../utils/vibecheck';

const API = config.emotifyApi.url;

export interface VibeToday {
  date: string;
  number: number;
  clipStart: number;
  clipSeconds: number;
  clips: string[];
  nextResetAt: string;
}

export interface VibeStats {
  total: number;
  histogram: number[];
}

export interface ResultResponse {
  total: number;
  stats: VibeStats;
  bucketSize: number;
  betterThan: number | null;
  alreadySubmitted: boolean;
}

export class VibeError extends Error {
  constructor(message: string, public status: number) {
    super(message);
  }
}

const request = async <T>(path: string, init?: RequestInit): Promise<T> => {
  let resp: Response;
  try {
    resp = await fetch(`${API}${path}`, init);
  } catch {
    throw new VibeError('Unable to reach the service. Check your connection and try again.', 0);
  }
  const body = await resp.json().catch(() => ({}));
  const data = typeof body?.body === 'string' ? JSON.parse(body.body) : body;
  if (!resp.ok) throw new VibeError(data?.error || `Request failed (${resp.status})`, resp.status);
  return data as T;
};

const post = <T>(path: string, payload: unknown) =>
  request<T>(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });

export const getToday = () => request<VibeToday>('vibecheck/today');

export const submitGuess = (round: number, pin: Pin) => post<Reveal>('vibecheck/guess', { round, ...pin });

export const submitResult = (playerId: string, guesses: Pin[]) =>
  post<ResultResponse>('vibecheck/result', { playerId, guesses });
